// extracted by mini-css-extract-plugin
export default {"page":"myAccount_page__6Q62z","pageHeader":"myAccount_pageHeader__t8awD"};